const Sport_Common_JSON = {
   game_menu: {
      tool_block: [
         // {
         //    hidden: false,
         //    jsx: {
         //       text: 'Record',
         //       icon: 'faBullhorn',
         //       type: 'standard',
         //       class: 'Btn_toolSolid testClass'
         //    },
         //    fun: [
         //       { type: 'megaPhone_test', value: ''},
         //    ],
         // },
         {
            hidden: false,
            jsx: {
               text: '',
               icon: 'cast_btn',
               type: 'standard',
               class: 'Btn_toolSolid'
            },
            fun: [
               { type: 'cast_btn', value: '' },
            ],
         },

      ]
   },
   settings_menu: {
      tool_block: [
         {
            pos: 0,
            hidden: false,
            dep: [{ type: 'account_logged_in', value: false }],
            jsx: {
               text: 'Login',
               icon: 'faCircleUser',
               type: 'standard',
               class: 'Btn_toolSolid',
            },
            fun: { type: 'login', value: '', },
         },
         {
            pos: 0,
            hidden: false,
            dep: [{ type: 'account_logged_in', value: true }],
            jsx: {
               text: 'Logout',
               icon: 'faCircleUser',
               type: 'standard',
               class: 'Btn_toolSolid',
            },
            fun: { type: 'logout', value: '', },
         },
         {
            pos: 1,
            hidden: false,
            dep: [],
            jsx: {
               text: 'Change Device',
               icon: 'faMobile',
               type: 'standard',
               class: 'Btn_toolSolid',
            },
            fun: { type: 'change_device_reg', value: '', },
         },
         {
            pos: 2,
            hidden: false,
            dep: [],
            jsx: {
               text: 'Change Sport',
               icon: 'faRepeat',
               type: 'standard',
               class: 'Btn_toolSolid',
            },
            fun: { type: 'change_sport_reg', value: '', },
         },
         {
            pos: 3,
            hidden: false,
            dep: [],
            jsx: {
               text: 'Clear Database',
               icon: 'faDatabase',
               type: 'standard',
               class: 'Btn_toolSolid',
            },
            fun: { type: 'clear_database', value: '', },
         },
      ]
   }, 

   hot_keys: {
      keys: [
         {
            action: 'track_next',
            keys: [ 'MediaTrackNext', 'b' ],
         },
         {
            action: 'track_previous',
            keys: [ 'MediaTrackPrevious', 'a' ],
         },
         {
            action: 'play_pause',
            keys: [ 'MediaPlayPause', 'c' ],
         },
      ],
      actions: [
         {
            screen: 'confirm_box',
            condition: null,
            fun: [{ type: 'confirm_box_deny', value: '', }],
            keys: [ 'track_next', 'track_previous'],
         },
         {
            screen: 'confirm_box',
            condition: null,
            fun: [{ type: 'confirm_box_confirm', value: '', }],
            keys: [ 'play_pause'],
         },
         {
            screen: 'warm_up_screen',
            condition: null,
            fun: [{ type: 'startMatch', value: 0 }],
            keys: [ 'play_pause'  ],
         },
         {
            screen: 'serving_selector_confirm_box',
            condition: null,
            // fun: [{ type: 'select_player_1_serving', value: '', }],
            fun: [{ type: 'select_server', value: 1, }],
            keys: [ 'track_previous'  ],
         },
         {
            screen: 'serving_selector_confirm_box',
            condition: null,
            fun: [{ type: 'select_server', value: 2, }],
            keys: [ 'track_next'  ],
         },
         {
            screen: 'scoring_screen',
            condition: null,
            fun: [{ type: 'score', value: 1 }],
            keys: [ 'track_previous'  ],
         },
         {
            screen: 'scoring_screen',
            condition: null,
            fun: [{ type: 'score', value: 2 }],
            keys: [ 'track_next'  ],
         },
         // {
         //    screen: 'scoring_screen',
         //    condition: [ { type: 'team_1_score_not', value: 0 }, { type: 'team_2_score_not', value: 0 } ],
         //    fun: { type: 'speechFun', value: 'play_button', },
         //    keys: [ 'play_pause'  ],
         // },
         {
            screen: 'scoring_screen',
            condition: [{ type: 'current_game_total_logs_greater', value: 0 }],
            fun: [ { type: 'score_undo', value: '', }, { type: 'speech', value: 'undo', }],
            keys: [ 'play_pause'  ],
         },
         {
            screen: 'between_game_screen',
            condition: null,
            fun: [ 
               {
                  type: 'setTimer', value: {
                     trigger: 1,
                     value: 90,
                     reverse: true,
                     id: 'between_timer',
                     action: [{
                        value: 0,
                        fun: { type: 'startMatch', value: '', }
                     },
                     {
                        value: 15,
                        fun: { type: 'speech', value: '15 Seconds, Remaining', }
                     },
                     ],
                  }
               },
               { type: 'speech', value: '90, seconds', }
             ],
            keys: [ 'track_previous'  ],
         },
         {
            screen: 'between_game_screen',
            condition: null,
            fun: [
               {
                  type: 'setTimer', value: {
                     trigger: 1,
                     value: 120,
                     reverse: true,
                     id: 'between_timer',
                     action: [
                        {
                           value: 0,
                           fun: { type: 'startMatch', value: '', }
                        },
                        {
                           value: 15,
                           fun: { type: 'speech', value: '15 Seconds, Remaining', }
                        },
                     ]
                  }
               },
               { type: 'speech', value: '120, seconds', }
            ],
            keys: [ 'track_next' ],
         },
         {
            screen: 'between_game_screen',
            condition: null,
            fun: [{ type: 'startMatch', value: 0 }],
            keys: [ 'play_pause' ],
         },
         {
            screen: 'end_game_pause',
            condition: null,
            fun: [ 
               {
                  type: 'setTimer', value: {
                     trigger: 1,
                     value: 90,
                     reverse: true,
                     id: 'between_timer',
                     action: [{
                        value: 0,
                        fun: { type: 'startMatch', value: '', }
                     },
                     {
                        value: 15,
                        fun: { type: 'speech', value: '15 Seconds, Remaining', }
                     },
                     ],
                  }
               },
               { type: 'speech', value: '90, seconds', }
             ],
            keys: [ 'track_previous'  ],
         },
         {
            screen: 'end_game_pause',
            condition: null,
            fun: [
               {
                  type: 'setTimer', value: {
                     trigger: 1,
                     value: 120,
                     reverse: true,
                     id: 'between_timer',
                     action: [
                        {
                           value: 0,
                           fun: { type: 'startMatch', value: '', }
                        },
                        {
                           value: 15,
                           fun: { type: 'speech', value: '15 Seconds, Remaining', }
                        },
                     ]
                  }
               },
               { type: 'speech', value: '120, seconds', }
            ],
            keys: [ 'track_next' ],
         },
         {
            screen: 'end_game_pause',
            condition: null,
            fun: [{ type: 'startMatch', value: 0 }],
            keys: [ 'play_pause' ],
         },
      ]
   }
}

export default Sport_Common_JSON;